import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QueryService } from '@app/core/graphql/query/query.service';
import { State } from '@app/core/ngrx/reducers';
import { userSelectors } from '@app/core/ngrx/selectors';
import { UserService } from '@app/core/services/user/user.service';
import { ModalService } from '@core/services/modal/modal.service';
import { WarningService } from '@app/core/services/warning/warning.service';
import { isNil } from '@app/shared/utils';
import { Store } from '@ngrx/store';
import { flatMap } from 'rxjs/operators';
import { faExclamationCircle, faTasks } from '@fortawesome/pro-regular-svg-icons';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
    selector: 'app-document-additional-doc',
    templateUrl: './document-additional-doc.component.html',
    styleUrls: ['./document-additional-doc.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class DocumentAdditionalDocComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private queryService: QueryService,
        private store: Store<State>,
        private userService: UserService,
        private modalService: ModalService,
        private warning: WarningService,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager
    ) {
        this.$USER_ID.subscribe((userid: string) => (this.USER_ID = userid));
    }

    documents: any[] = [];

    malpracticeDocuments: any[] = [];

    $USER_ID = this.store.select(userSelectors.getUserID);
    USER_ID: string;

    faExclamationCircle = faExclamationCircle;

    loading: boolean = true;

    loadingText = Array.from(Array(50)).keys();

    ngOnInit() {
        this.route.params
            .pipe(
                flatMap((params: any) => {
                    if (isNil(params.applicationid)) {
                        throw new Error(`Params application id is invalid.  ${params}`);
                    } else {
                        return this.queryService.applicationDocumentRequirementsList(params.applicationid);
                    }
                })
            )
            .subscribe(
                (res: any) => {
                    let rawDocuments = [...res.data.singleApplicationRequirementList.documents];

                    const submittedRequirements = [...res.data.submittedDocumentsRequirements.documents];

                    this.malpracticeDocuments = [...res.data.applicationMalpracticeDocument.documents];

                    if (rawDocuments.length > 0) {
                        this.documents = rawDocuments
                            .map((a) => {
                                return {
                                    name: a['ApplicationRequirements.jsondata'].name,
                                    applicationRequirementId: a['ApplicationRequirements.applicationRequirementId'],
                                    type: a['ApplicationRequirements.jsondata'].type,
                                    level: a.level,
                                    levelId:
                                        a.programid !== null ? a.programid : a.departmentid !== null ? a.departmentid : a.hostid !== null ? a.hostid : null,
                                };
                            })
                            .filter((a) => {
                                if (submittedRequirements.some((b) => b === a.applicationRequirementId)) {
                                    return a;
                                }
                            });
                    }
                    this.loading = false;
                },
                (err) => {
                    this.warning.create('We were unable to load this page. Please contact support for assistance.');
                    this.loading = false;
                }
            );
    }

    viewDocument(document: any) {
        this.angulartics2GoogleTagManager.eventTrack('Downloaded Application Document', { category: 'Application Documents' });

        const request = {
            userid: this.USER_ID,
            applicationRequirementId: document.applicationRequirementId,
            type: document.type,
            level: document.level,
            levelId: document.levelId,
            name: document.name,
        };

        this.userService.getUploadedDocuments(request).subscribe((res: any) => {
            if (res.success && res.url) {
                window.open(res.url, '_blank');
            } else {
                this.warning.create('We were unable to retrieve your document. Please contact support for assistance.');
            }
        });
    }

    viewMalpracticeDocument(document: any) {
        this.angulartics2GoogleTagManager.eventTrack('Downloaded Application Document', { category: 'Application Documents' });

        if (document.url) {
            window.open(document.url, '_blank');
        } else {
            this.warning.create('We were unable to retrieve your document. Please contact support for assistance.');
        }
    }

    clearAdditionalReqDocument(document: any) {
        let filename = `userdocuments/${this.USER_ID}/requirements/${document.applicationRequirementId}/${document.level}/${document.levelId}/`;
        const request = {
            userid: this.USER_ID,
            itemno: -1, // < 0 means that its an app doc and not a regular user doc
            originalfilename: filename,
        };
        let usrService = this.userService.archiveUploadedDocument;

        this.modalService
            .confirmation({
                title: 'Cancel Document',
                message: `
            You are about to clear the "${document.name}" document: \n\n`,
                buttonText: `Yes, clear this document.`,
                buttonColor: 'danger',
            })
            .then(function (result) {
                if (result.data.confirmed) {
                    usrService(request).subscribe((res) => {
                        if (res.success) {
                            location.reload();
                        }
                    });
                }
            });
    }

    clearMalpracticeDocument(document: any) {
        let filename = document.url.split('.com/')[1].split('?')[0];
        const request = {
            userid: this.USER_ID,
            itemno: -1, // < 0 means that its an app doc and not a regular user doc
            originalfilename: filename,
        };
        let usrService = this.userService.archiveUploadedDocument;

        this.modalService
            .confirmation({
                title: 'Cancel Document',
                message: `
            You are about to clear your malpractice document: \n\n`,
                buttonText: `Yes, clear this document.`,
                buttonColor: 'danger',
            })
            .then(function (result) {
                if (result.data.confirmed) {
                    usrService(request).subscribe((res) => {
                        if (res.success) {
                            location.reload();
                        }
                    });
                }
            });
    }
}
